// extracted by mini-css-extract-plugin
export var copyableField = "_rb-4";
export var customerBadge = "_rb-0";
export var customerInfoTitle = "_rb-2";
export var details = "_rb-1";
export var dropdownContainer = "_rb-5";
export var dropdownImage = "_rb-6";
export var editAssigneeForm = "_rb-a";
export var editButton = "_rb-3";
export var email = "_rb-7";
export var hidden = "_rb-d";
export var input = "_rb-8";
export var saveButton = "_rb-b";
export var shopifyIcon = "_rb-c";
export var suggestionBadge = "_rb-e";
export var suggestionText = "_rb-f";
export var username = "_rb-9";